import client from '../../client';

const USER = {
  updateUser(params) {
    return client.put(`/sellers/users/${client.customerId()}`, { user: params })
  },
}

export default USER;
